import DefaultHeading from '@/components/Grid/components/header/Heading';
import { GridProvider, useBuildGrid, DefaultGrid } from '@Components/Grid';

import { useIntegrationStore } from '../../store';
import HeaderButtons from '../HeaderButtons';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'
import useFilters from './useFilters'

function IntegrationGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
    events: useEvents(),
  })

  return <DefaultGrid
    heading={<DefaultHeading>
      <HeaderButtons />
    </DefaultHeading>}
  />
}

export default function IntegrationGridLayout() {
  return <GridProvider store={useIntegrationStore()}>
    <IntegrationGrid />
  </GridProvider>
}
